import product2_1 from '../assets/Product2.1.jpeg';
import product2_2 from '../assets/Product2.2.jpeg';
import product2_3 from '../assets/Product2.3.jpeg';
import product2_4 from '../assets/Product2.4.jpeg';

import product3_1 from '../assets/Product3.1.jpeg';
import product3_2 from '../assets/Product3.2.jpeg';
import product3_3 from '../assets/Product3.3.jpeg';
import product3_4 from '../assets/Product3.4.jpeg';

import product4_1 from '../assets/Product4.1.jpeg';
import product4_2 from '../assets/Product4.2.jpeg';
import product4_3 from '../assets/Product4.3.jpeg';
import product4_4 from '../assets/Product4.4.jpeg';

import product5_1 from '../assets/Product5.1.jpeg';
import product5_2 from '../assets/Product5.2.jpeg';
import product5_3 from '../assets/Product5.3.jpeg';



export const products = [
  
  {
    id: 2,
    name: "UltraSoft Micro Trunks",
    category: "Trunks",
    price: 399,
    images: [product2_2, product2_3, product2_4, product2_1]
  },
  {
    id: 3,
    name: "Performance Flex Trunks",
    category: "Trunks",
    price: 399,
    images: [product3_1, product3_2, product3_3, product3_4]
  },
  {
    id: 4,
    name: "AirMesh Gym Tank",
    category: "Gym Wear",
    price: 399,
    images: [product4_1, product4_2, product4_3, product4_4]
  },
  {
    id: 5,
    name: "Core Stretch Sando",
    category: "Trunks",
    price: 399,
    images: [product5_1, product5_2, product5_3]
  },

  
];

export const categories = ["All", "Trunks", "Gym Wear"];

